"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _errorParse = require("@/utils/error-parse");
var _expense = require("@/api/expense");
var _elementUi = require("element-ui");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  components: {
    Pagination: _Pagination.default
  },
  data() {
    return {
      list: null,
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 10
      },
      total: 0
    };
  },
  computed: {
    device() {
      return this.$store.state.app.device;
    } /* ,
      ...mapGetters([
       'name'
      ]) */
  },

  async created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.listLoading = true;
      (0, _expense.getExpenses)(this.listQuery).then(response => {
        this.list = response.data;
        this.total = response?.meta?.total ?? 10; // @TODO check availibility
        this.list.forEach((data, index) => {
          data.id = index + response.meta.from;
        });
      }).finally(() => {
        this.listLoading = false;
      });
    },
    deleteExpense(id) {
      return _elementUi.MessageBox.confirm('Confirm to delete Expense?', 'Confirm', {
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => (0, _expense.deleteExpense)(id).catch(err => err.status === 404 ? Promise.resolve('already deleted') : (0, _elementUi.Message)({
        dangerouslyUseHTMLString: true,
        message: (0, _errorParse.parseError)(err) || 'Delete failed, please retry.',
        type: 'error',
        duration: 5 * 1000
      })).then(() => {
        (0, _elementUi.Message)({
          message: 'Expense deleted',
          type: 'success',
          duration: 5 * 1000
        });
        return this.fetchData();
      })).catch(err => err === 'cancel' ? Promise.resolve('cancelled') : Promise.reject(err));
    }
  }
};
exports.default = _default;